<div class="component-wrapper">
  <div *ngIf="!isLoading && data">
    <div class="heading">
      <h2>{{ 'response.stl_download.header' | translate }} {{ data.orderId }}</h2>
    </div>
    <div class="sub-heading">
      <h2>{{ 'response.stl_download.base_set' | translate }}</h2>
    </div>
    <div class="side-container">
      <div class="product-container" *ngIf="data.left && data.left.baseSetProducts">
        <h3>{{ 'response.stl_download.left' | translate }}</h3>

        <!-- Use ng-container to apply *ngIf to the block -->
        <ng-container *ngFor="let product of data.left.baseSetProducts | keyvalue">
          <ng-container *ngIf="product.value.productName || product.value.orderProductId">
            <div class="product">
              <div class="product-data">
                <p>{{ product.value.productName }}</p>
                <p *ngIf="product.value.serialNumber; else showText">
                  {{ product.value.serialNumber }}
                </p>
                <ng-template #showText>
                  <p>{{ 'response.stl_download.serial_number' | translate }}</p>
                </ng-template>
              </div>

              <ng-container
                *ngIf="clickedButtonOrderId !== product.value.orderProductId; else loaderTemplate"
              >
                <a
                  *ngIf="!preparedDownloadUrls[product.value.orderProductId]"
                  type="button"
                  class="btn btn-primary me-2 mb-2"
                  (click)="startDownload(data.orderId.toString(), product.value.orderProductId)"
                  [ngClass]="{
                    isDisabled:
                      downloadInProgress && clickedButtonOrderId !== product.value.orderProductId
                  }"
                >
                  {{ 'response.stl_download.prepare' | translate }}
                </a>
                <a
                  *ngIf="preparedDownloadUrls[product.value.orderProductId]"
                  [href]="preparedDownloadUrls[product.value.orderProductId].url"
                  [download]="preparedDownloadUrls[product.value.orderProductId].fileName"
                  class="btn btn-mowa-blue me-2 mb-2"
                >
                  {{ 'response.stl_download.download' | translate }}
                </a>
              </ng-container>

              <ng-template #loaderTemplate>
                <div class="loader-template d-flex justify-content-center align-items-center">
                  <span>{{ 'response.stl_download.preparing' | translate }}</span>
                  <div class="loader"></div>
                </div>
              </ng-template>
            </div>
          </ng-container>
        </ng-container>
      </div>

      <div class="product-container" *ngIf="data.right && data.right.baseSetProducts">
        <h3>{{ 'response.stl_download.right' | translate }}</h3>

        <!-- Use ng-container to apply *ngIf to the block -->
        <ng-container *ngFor="let product of data.right.baseSetProducts | keyvalue">
          <ng-container *ngIf="product.value.productName || product.value.orderProductId">
            <div class="product">
              <div class="product-data">
                <p>{{ product.value.productName }}</p>
                <p *ngIf="product.value.serialNumber; else showText">
                  {{ product.value.serialNumber }}
                </p>
                <ng-template #showText>
                  <p>{{ 'response.stl_download.serial_number' | translate }}</p>
                </ng-template>
              </div>

              <ng-container
                *ngIf="clickedButtonOrderId !== product.value.orderProductId; else loaderTemplate"
              >
                <a
                  *ngIf="!preparedDownloadUrls[product.value.orderProductId]"
                  type="button"
                  class="btn btn-primary me-2 mb-2"
                  (click)="startDownload(data.orderId.toString(), product.value.orderProductId)"
                  [ngClass]="{
                    isDisabled:
                      downloadInProgress && clickedButtonOrderId !== product.value.orderProductId
                  }"
                >
                  {{ 'response.stl_download.prepare' | translate }}
                </a>
                <a
                  *ngIf="preparedDownloadUrls[product.value.orderProductId]"
                  [href]="preparedDownloadUrls[product.value.orderProductId].url"
                  [download]="preparedDownloadUrls[product.value.orderProductId].fileName"
                  class="btn btn-mowa-blue me-2 mb-2"
                >
                  {{ 'response.stl_download.download' | translate }}
                </a>
              </ng-container>

              <ng-template #loaderTemplate>
                <div class="loader-template d-flex justify-content-center align-items-center">
                  <span>{{ 'response.stl_download.preparing' | translate }}</span>
                  <div class="loader"></div>
                </div>
              </ng-template>
            </div>
          </ng-container>
        </ng-container>
      </div>

      <div class="no-data" *ngIf="!data.right.baseSetProducts && !data.left.baseSetProducts">
        <p>{{ 'response.stl_download.no_base_set' | translate }}</p>
      </div>
    </div>
    <div class="sub-heading">
      <h2>{{ 'response.stl_download.custom_set' | translate }}</h2>
    </div>
    <div class="side-container">
      <div class="product-container basic-set" *ngIf="data.left && data.left.additionalProducts">
        <h3>{{ 'response.stl_download.left' | translate }}</h3>
        <div class="product" *ngFor="let product of data.left.additionalProducts | keyvalue">
          <div class="product-data">
            <p>{{ product.value.productName }}</p>
            <p *ngIf="product.value.serialNumber; else showText">
              {{ product.value.serialNumber }}
            </p>
            <ng-template #showText>
              <p>{{ 'response.stl_download.serial_number' | translate }}</p>
            </ng-template>
          </div>
          <ng-container
            *ngIf="clickedButtonOrderId !== product.value.orderProductId; else loaderTemplate"
          >
            <a
              type="button"
              class="btn btn-primary me-2 mb-2"
              *ngIf="!preparedDownloadUrls[product.value.orderProductId]"
              (click)="startDownload(data.orderId.toString(), product.value.orderProductId)"
              [ngClass]="{
                isDisabled:
                  downloadInProgress && clickedButtonOrderId !== product.value.orderProductId
              }"
            >
              {{ 'response.stl_download.prepare' | translate }}
            </a>
            <a
              *ngIf="preparedDownloadUrls[product.value.orderProductId]"
              [href]="preparedDownloadUrls[product.value.orderProductId].url"
              [download]="preparedDownloadUrls[product.value.orderProductId].fileName"
              class="btn btn-mowa-blue me-2 mb-2"
            >
              {{ 'response.stl_download.download' | translate }}
            </a>
          </ng-container>
          <ng-template #loaderTemplate>
            <div class="loader-template d-flex justify-content-center align-items-center">
              <span>{{ 'response.stl_download.preparing' | translate }}</span>
              <div class="loader"></div>
            </div>
          </ng-template>
        </div>
      </div>

      <div class="product-container custom-set" *ngIf="data.right && data.right.additionalProducts">
        <h3>{{ 'response.stl_download.right' | translate }}</h3>
        <div class="product" *ngFor="let product of data.right.additionalProducts | keyvalue">
          <div class="product-data">
            <p>{{ product.value.productName }}</p>
            <p *ngIf="product.value.serialNumber; else showText">
              {{ product.value.serialNumber }}
            </p>
            <ng-template #showText>
              <p>{{ 'response.stl_download.serial_number' | translate }}</p>
            </ng-template>
          </div>
          <ng-container
            *ngIf="clickedButtonOrderId !== product.value.orderProductId; else loaderTemplate"
          >
            <a
              type="button"
              class="btn btn-primary me-2 mb-2"
              *ngIf="!preparedDownloadUrls[product.value.orderProductId]"
              (click)="startDownload(data.orderId.toString(), product.value.orderProductId)"
              [ngClass]="{
                isDisabled:
                  downloadInProgress && clickedButtonOrderId !== product.value.orderProductId
              }"
            >
              {{ 'response.stl_download.prepare' | translate }}
            </a>
            <a
              *ngIf="preparedDownloadUrls[product.value.orderProductId]"
              [href]="preparedDownloadUrls[product.value.orderProductId].url"
              [download]="preparedDownloadUrls[product.value.orderProductId].fileName"
              class="btn btn-mowa-blue me-2 mb-2"
            >
              {{ 'response.stl_download.download' | translate }}
            </a>
          </ng-container>
          <ng-template #loaderTemplate>
            <div class="loader-template d-flex justify-content-center align-items-center">
              <span>{{ 'response.stl_download.preparing' | translate }}</span>
              <div class="loader"></div>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="isLoading" class="table-loader">
    <mat-progress-spinner
      color="primary"
      mode="indeterminate"
      class="loader-status"
      [diameter]="80"
    >
    </mat-progress-spinner>
  </div>
</div>

<!-- MODAL -->
<div *ngIf="modal" class="modal-container" (click)="closeModal()">
  <div class="modal-content text-center">
    <div class="close-btn">
      <img src="../../../assets/icons/close.png" alt="" />
    </div>
    <div *ngIf="!error">
      <h2 class="pb-3">{{ 'INFO' }}</h2>
      <h3>{{ modalText | translate }}</h3>
      <div class="d-flex justify-content-center">
        <button
          class="btn btn-dark btn-disabled m-2"
          *ngFor="let server of availableServerForDownload"
        >
          {{ server }}
        </button>
      </div>
    </div>
    <div *ngIf="error">
      <h2 class="pb-3">{{ 'ERROR:' }}</h2>
      <h3>{{ modalText | translate }}</h3>
      <div class="d-flex justify-content-center">
        <button class="btn btn-dark m-2" (click)="siteReload()">
          {{ 'response.stl_download.retry' | translate }}
        </button>
        <button class="btn btn-dark m-2" (click)="navigateHome()">
          {{ 'response.stl_download.go_home' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
